export default {
  // 合同管理
  contractManagement: {
    title: '合同管理',
    description: '管理运输合同和协议'
  },

  // 合约管理
  contracts: {
    title: '合约管理',
    description: '管理船公司合约和约价信息',

    // 筛选条件
    filters: {
      keyword: '关键词搜索',
      keywordPlaceholder: '请输入船公司约号、适用品名或NAC编码',
      shipCompany: '船公司',
      shipCompanyPlaceholder: '请选择船公司',
      contractNature: '约价性质',
      contractNaturePlaceholder: '请选择约价性质',
      status: '状态',
      statusPlaceholder: '请选择状态',
      applicableCommodity: '适用品名',
      applicableCommodityPlaceholder: '请选择适用品名',
      applicableRoute: '适用航线',
      applicableRoutePlaceholder: '请选择适用航线',
      spaceGuarantee: '舱保',
      spaceGuaranteePlaceholder: '请选择舱保',
      mqcRange: 'MQC范围',
      mqcMinPlaceholder: '最小MQC',
      mqcMaxPlaceholder: '最大MQC',
      effectiveDateRange: '有效期',
      startDatePlaceholder: '开始日期',
      endDatePlaceholder: '结束日期',
      nacCodes: 'NAC编码',
      nacCodesPlaceholder: '请输入NAC编码进行搜索',
      contractNumber: '船公司约号',
      contractNumberPlaceholder: '请输入船公司约号'
    },

    // 状态
    status: {
      enabled: '启用',
      disabled: '禁用'
    },

    // 批量操作
    batchActions: {
      operations: '批量操作 ({count})',
      selected: '已选择 {count} 条记录',
      enable: '批量启用',
      disable: '批量禁用'
    },

    // 工具栏
    toolbar: {
      batchExportExcel: '批量导出Excel',
      batchExportCsv: '批量导出CSV'
    },

    // 操作按钮
    actions: {
      add: '新增合约',
      edit: '编辑',
      copy: '复制',
      enable: '启用',
      disable: '禁用',
      delete: '删除'
    },

    // 新增合约
    add: {
      title: '新增合约',
      basicInfo: '基本信息',
      routeInfo: '适用航线',
      validityInfo: '有效期',
      validityPeriod: '有效期',
      nacInfo: 'NAC配置',
      contractNumberPlaceholder: '请输入船公司约号',
      carrierPlaceholder: '请选择船公司',
      pricingNaturePlaceholder: '请选择约价性质',
      commodityPlaceholder: '请选择适用品名',
      mqcPlaceholder: '请输入MQC数量（选填）',
      spaceGuaranteePlaceholder: '请输入舱保数量（TEU/月），留空表示未填写',
      routePlaceholder: '请选择适用航线',
      effectiveDate: '生效日期',
      expiryDate: '失效日期',
      effectiveDatePlaceholder: '请选择生效日期',
      expiryDatePlaceholder: '请选择失效日期',
      nacPlaceholder: '请输入NAC（大写字母数字组合）',
      nacInputHint: '注意：NAC只能包含大写字母和数字，按回车或失焦自动添加',
      addNac: '添加NAC',
      statusPlaceholder: '请选择状态',
      saveAndNew: '保存并新增'
    },

    // 编辑合约
    edit: {
      title: '编辑合约',
      basicInfo: '基本信息',
      routeInfo: '适用航线',
      validityInfo: '有效期',
      nacInfo: 'NAC配置',
      contractNumberPlaceholder: '请输入船公司约号',
      carrierPlaceholder: '请选择船公司',
      pricingNaturePlaceholder: '请选择约价性质',
      commodityPlaceholder: '请选择适用品名',
      mqcPlaceholder: '请输入MQC数量（选填）',
      spaceGuaranteePlaceholder: '请输入舱保数量（TEU/月），留空表示未填写',
      routePlaceholder: '请选择适用航线',
      effectiveDate: '生效日期',
      expiryDate: '失效日期',
      effectiveDatePlaceholder: '请选择生效日期',
      expiryDatePlaceholder: '请选择失效日期',
      nacPlaceholder: '请输入NAC（大写字母数字组合）',
      nacInputHint: '注意：NAC只能包含大写字母和数字，按回车或失焦自动添加',
      addNac: '添加NAC'
    },

    // 表单验证
    validation: {
      contractNumberRequired: '请输入船公司约号',
      contractNumberLength: '船公司约号长度应在1-50个字符之间',
      contractNumberExists: '该约号已存在，请使用其他约号',
      carrierRequired: '请选择船公司',
      pricingNatureRequired: '请选择约价性质',
      routeRequired: '请选择适用航线',
      commodityRequired: '请选择适用品名',
      mqcRequired: '请输入MQC数量',
      mqcRange: 'MQC数量应在1-99999之间',
      spaceGuaranteeRequired: '请选择舱保',
      spaceGuaranteeRange: '舱保数值应在0-999999之间',
      effectiveDateRequired: '请选择生效日期',
      expiryDateRequired: '请选择失效日期',
      nacRequired: '请至少添加一个NAC',
      nacMinLength: '请至少添加一个NAC',
      nacFormatInvalid: 'NAC格式不正确，只能包含大写字母和数字',
      nacAlreadyExists: '该NAC已存在',
      statusRequired: '请选择状态'
    },

    // 表格列
    columns: {
      shipCompanyNumber: '船公司约号',
      applicableRoute: '适用航线',
      shipCompany: '船公司',
      contractNature: '约价性质',
      destinationName: '适用品名',
      nacs: 'NAC',
      mqc: 'MQC',
      configuration: '舱保',
      effectiveDate: '有效期',
      status: '状态'
    },

    // 表格提示
    table: {
      allRoutes: '所有适用航线：',
      allNacs: '所有NAC：'
    },

    // 字段
    fields: {
      shipCompanyNumber: '船公司约号',
      applicableRoute: '适用航线',
      shipCompany: '船公司',
      contractNature: '约价性质',
      destinationName: '适用品名',
      nacs: 'NAC',
      mqc: 'MQC',
      configuration: '舱保',
      effectiveDate: '有效期',
      status: '状态'
    },

    // 导出
    export: {
      filename: '合约管理数据'
    },

    // 消息提示
    messages: {
      addSuccess: '新增合约成功',
      updateSuccess: '更新合约成功',
      deleteSuccess: '删除合约成功',
      enabledSuccess: '启用成功',
      disabledSuccess: '禁用成功',
      batchEnableSuccess: '批量启用成功',
      batchDisableSuccess: '批量禁用成功',
      disabledFailed: '禁用失败',
      selectEnableRecords: '请先选择要启用的记录',
      selectDisableRecords: '请先选择要禁用的记录',
      copyInitiated: '已复制到新增页面',
      copyDataLoaded: '复制数据加载成功',
      copyFailed: '复制数据失败',
      saveFailedStatus: '保存合约失败：服务器返回失败状态',
      saveFailed: '保存合约失败',
      idRequired: '合约ID不能为空',
      fetchFailedEmpty: '获取合约详情失败：响应为空',
      fetchFailed: '获取合约详情失败',
      updateFailedStatus: '更新合约失败：服务器返回失败状态',
      updateFailed: '更新合约失败'
    },

    // 详情页面和弹窗
    detail: {
      title: '合约详情',
      basicInfo: '基本信息',
      routeInfo: '适用航线信息',
      nacInfo: 'NAC配置信息',
      validityInfo: '有效期与状态',
      noRoutes: '暂无适用航线',
      noNacs: '暂无NAC配置'
    },

    // 确认弹窗
    confirm: {
      title: '确认操作',
      deleteTitle: '确认删除',
      enableTitle: '确认启用',
      disableTitle: '确认禁用',
      batchEnableTitle: '确认批量启用',
      batchDisableTitle: '确认批量禁用',
      enableMessage: '确定要启用选中的 {count} 条合约吗？',
      disableMessage: '确定要禁用选中的 {count} 条合约吗？',
      singleEnableMessage: '确定要启用该合约吗？',
      singleDisableMessage: '确定要禁用该合约吗？',
      deleteMessage: '确定要删除合约 "{number}" 吗？此操作不可恢复。'
    }
  },

  // 合约管理相关枚举翻译
  enums: {
    // 约价性质枚举
    pricingNature: {
      selfPricing: 'FAK',
      customerPricing: '客约价',
      overseasAgentPricing: '海外代理约价',
      noPricing: '无约价',
      peerPricing: '同行约价',
      bcoContract: 'NAC/FIX',
      afcPricing: 'AFC约价',
      mixedPricing: '配比约价'
    },

    // 适用品名枚举
    commodity: {
      fak: 'FAK',
      dangerousGoods: '危险品',
      specialContainer: '特种柜',
      frozenGoods: '冻品',
      chemicalGoods: '化工品',
      textileGoods: '纺织品',
      other: '其他'
    },

    // 舱保枚举
    spaceGuarantee: {
      guarantee20: '有 (20 TEU/月)',
      guarantee50: '有 (50 TEU/月)',
      guarantee100: '有 (100 TEU/月)',
      guarantee300: '有 (300 TEU/月)',
      noGuarantee: '无'
    },

    // 合约状态枚举
    contractStatus: {
      enabled: '启用',
      disabled: '禁用'
    }
  }
}
